import { get } from '../../../../DAL/data-provider';

export const getTopMiniCartCount = async () => {
    return get('/api/shoppingcart/get-product-count');
};